import { useMemo } from 'react'
import { useAppSelector } from 'src/store/hooks'
import { useAutoFetch } from 'src/v3/hooks/use-auto-fetch'
import {
  fetchAccreditations,
  fetchEventAccreditations,
  fetchEvents,
  selectAccreditations,
  selectAccreditationsStatus,
  selectEventAccreditations,
  selectEventAccreditationsStatus,
  selectEvents,
  selectEventsStatus,
} from './events.slice'

export function useEventAccreditationValidation(
  linkedServiceID: string,
  kind: 'accredited' | 'notAccredited',
  currentAccreditationID?: string,
): (courseCode: string) => string | undefined {
  let eventsStatus = useAppSelector(selectEventsStatus)
  let accreditationsStatus = useAppSelector(selectAccreditationsStatus)
  let eventAccreditationsStatus = useAppSelector(
    selectEventAccreditationsStatus,
  )
  let allEvents = useAppSelector(selectEvents)
  let allEventAccreditations = useAppSelector(selectEventAccreditations)
  let allAccreditations = useAppSelector(selectAccreditations)

  useAutoFetch(eventsStatus, fetchEvents)
  useAutoFetch(accreditationsStatus, fetchAccreditations)
  useAutoFetch(eventAccreditationsStatus, fetchEventAccreditations)

  let takenCodesLower = useMemo(() => {
    let eventIDsForLinkedService = new Set(
      allEvents
        .filter((e) => e.linkedServiceID === linkedServiceID)
        .map((e) => e.id),
    )
    let accreditationIDsForEvents = new Set(
      allEventAccreditations
        .filter((ea) => eventIDsForLinkedService.has(ea.eventID))
        .map((ea) => ea.accreditationID),
    )
    return new Set(
      allAccreditations
        .filter(
          (a) =>
            a.kind === kind &&
            accreditationIDsForEvents.has(a.id) &&
            a.id !== currentAccreditationID,
        )
        .map((a) => ('courseCode' in a ? a.courseCode.toLowerCase() : '')),
    )
  }, [
    allEvents,
    allEventAccreditations,
    allAccreditations,
    linkedServiceID,
    kind,
    currentAccreditationID,
  ])

  return (courseCode: string) => {
    if (takenCodesLower.has(courseCode.toLowerCase())) {
      return 'This course code is already used by another event in this linked service'
    }
    return undefined
  }
}
